var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_166_2096)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 3.33317C1.6665 2.4127 2.4127 1.6665 3.33317 1.6665H6.6665C7.58698 1.6665 8.33317 2.4127 8.33317 3.33317V6.6665C8.33317 7.58698 7.58698 8.33317 6.6665 8.33317H3.33317C2.4127 8.33317 1.6665 7.58698 1.6665 6.6665V3.33317Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6665 3.33317C11.6665 2.4127 12.4127 1.6665 13.3332 1.6665H16.6665C17.587 1.6665 18.3332 2.4127 18.3332 3.33317V6.6665C18.3332 7.58698 17.587 8.33317 16.6665 8.33317H13.3332C12.4127 8.33317 11.6665 7.58698 11.6665 6.6665V3.33317Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 13.3332C1.6665 12.4127 2.4127 11.6665 3.33317 11.6665H6.6665C7.58698 11.6665 8.33317 12.4127 8.33317 13.3332V16.6665C8.33317 17.587 7.58698 18.3332 6.6665 18.3332H3.33317C2.4127 18.3332 1.6665 17.587 1.6665 16.6665V13.3332Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6665 13.3332C11.6665 12.4127 12.4127 11.6665 13.3332 11.6665H16.6665C17.587 11.6665 18.3332 12.4127 18.3332 13.3332V16.6665C18.3332 17.587 17.587 18.3332 16.6665 18.3332H13.3332C12.4127 18.3332 11.6665 17.587 11.6665 16.6665V13.3332Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_166_2096"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.62fe4cd50e19371f9031e7ec8a42bd01.svg";
export { ForwardRef as ReactComponent };